import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const convert = (val, prevUnit, curUnit) => {
  if (val === null || val === undefined) {
    return null;
  }
  let newVal = val;
  if (prevUnit === "C") {
    if (curUnit === "F") {
      newVal = ((1.0 * newVal) / 5) * 9 + 32;
    }
  } else if (prevUnit === "F") {
    if (curUnit === "C") {
      newVal = ((newVal - 32) / 9) * 5;
    }
  } else if (
    prevUnit === "ms" ||
    prevUnit === "sec" ||
    prevUnit === "min" ||
    prevUnit === "hour" ||
    prevUnit === "day"
  ) {
    if (prevUnit === "sec") {
      newVal = newVal * 1000;
    } else if (prevUnit === "min") {
      newVal = newVal * 1000 * 60;
    } else if (prevUnit === "hour") {
      newVal = newVal * 1000 * 60 * 60;
    } else if (prevUnit === "day") {
      newVal = newVal * 1000 * 60 * 60 * 24;
    }
    if (curUnit === "sec") {
      newVal = newVal / 1000;
    } else if (curUnit === "min") {
      newVal = newVal / 1000 / 60;
    } else if (curUnit === "hour") {
      newVal = newVal / 1000 / 60 / 60;
    } else if (curUnit === "day") {
      newVal = newVal / 1000 / 60 / 60 / 24;
    }
  }
  return newVal;
};

const normalizeByUnit = spec => {
  const regex = /^(-?[\d.]+)([a-zA-Z]+)$/;
  const match = regex.exec(spec.value);
  if (match && match.length === 3) {
    // unit value
    const number = parseFloat(match[1]);
    const unit = match[2];
    spec.number = number;
    if (unit === spec.unit) {
      return;
    }
    spec.min = convert(spec.min, spec.unit, unit);
    spec.max = convert(spec.max, spec.unit, unit);
    spec.unit = unit;
  } else {
    // no unit value
    spec.number = Number(spec.value);
  }
};

const NumberUnitInput = ({ valueSpec, onChange }) => {
  const [spec, setSpec] = useState(null);
  const [sValue, setSValue] = useState(0);
  const [tValue, setTValue] = useState(0);
  const [unit, setUnit] = useState(null);
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  const [step, setStep] = useState(null);

  useEffect(() => {
    normalizeByUnit(valueSpec);
    setSpec(valueSpec);
    setSValue(Number(valueSpec.number));
    setTValue(Number(valueSpec.number));
    setUnit(valueSpec.unit);
    setMin(valueSpec.min);
    setMax(valueSpec.max);
    if (valueSpec.steps) {
      for (let i = 0; i < valueSpec.steps.length; i++) {
        if (valueSpec.units[i] === valueSpec.unit) {
          setStep(valueSpec.steps[i]);
          break;
        }
      }
    } else {
      setStep(null);
    }
    return () => {};
  }, [valueSpec]);

  const handleUnitChange = event => {
    const prev = unit;
    const cur = event.target.value;
    if (prev === cur) {
      return;
    }
    setUnit(cur);
    // min, max
    const newMin = convert(min, prev, cur);
    setMin(newMin);
    const newMax = convert(max, prev, cur);
    setMax(newMax);
    // step
    for (let i = 0; i < spec.steps.length; i++) {
      if (spec.units[i] === cur) {
        setStep(spec.steps[i]);
        break;
      }
    }
    console.log(newMax);
    console.log(newMin);
    onChange(sValue.toString(), cur, newMax, newMin);
  };

  const handleSliderChange = (e, v) => {
    setSValue(v);
    setTValue(v);
    onChange(v.toString(), unit, max, min);
  };

  const handleNumberTextChange = event => {
    if (event.target.value === "") {
      setSValue(0);
      setTValue("");
    } else {
      const newValue = Number(event.target.value);
      setSValue(newValue);
      setTValue(newValue);
      onChange(newValue.toString(), unit, max, min);
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Grid container spacing={1} direction="column">
        {valueSpec.name && (
          <Grid item xs>
            <Typography variant="h6">{valueSpec.name}</Typography>
          </Grid>
        )}
        <Grid item xs>
          <Grid container spacing={1} columns={{ xs: 12 }}>
            {min !== null && max != null && (
              <Grid item xs={12}>
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{ paddingLeft: "8px", paddingRight: "8px" }}
                >
                  <Slider
                    value={sValue}
                    aria-label="Slider"
                    valueLabelDisplay="auto"
                    onChange={handleSliderChange}
                    min={min}
                    max={max}
                    step={step}
                  />
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container spacing={1} columns={{ xs: 12 }}>
                <Grid item xs={6}>
                  <TextField
                    label="Number"
                    type="number"
                    value={tValue}
                    onChange={handleNumberTextChange}
                    inputProps={{ min, max, step }}
                    fullWidth
                  />
                </Grid>
                {unit && (
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel id="unit-select-label">Unit</InputLabel>
                      <Select
                        labelId="unit-select-label"
                        id="unit-select"
                        value={unit}
                        label="Unit"
                        onChange={handleUnitChange}
                      >
                        {valueSpec.units.map(option => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NumberUnitInput;
